import React from 'react';
type Props = {
  children: string | null;
  count: string;
};
export function FacetLabel({ children }: Props) {
  if (!children) {
    // Safeguard: API can return facets with null names, that must be ignored.
    return null;
  }

  return <span>{children}</span>;
}
